module.exports = __webpack_public_path__ + "static/media/pie.c9ad6da7.svg";